<template>
    <span class="num" v-if="count > max">{{ $ft.formatNum(max) }}+</span>
    <span class="num" v-else-if="count > 0">{{ $ft.formatNum(count) }}</span>
    <span class="num" v-else-if="count === 0">0</span>
</template>

<script>
const MAX_COUNT = 999;
export default {
    props: {
        count: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            max: MAX_COUNT
        }
    }
};
</script>
